module.exports = __webpack_public_path__ + "img/sint-maarten.dde608cd.png";